import { Component } from '@angular/core';
import { DataLoaderService } from '../../../../services/data-loader.service';
@Component({
    selector: 'expert-cancel-confirmation',
    templateUrl: './expert-cancel-confirmation.template.html',
    styleUrls: ['./expert-cancel-confirmation.component.css']
})

export class ExpertCancelComponent {
    private options: any;
    constructor(private dataLoaderService: DataLoaderService) {
    }

    ngOnInit() {
    }

    cancelConfiguration() {
        (<HTMLInputElement>document.getElementById('RETCODEID')).value = '0';
        (<HTMLFormElement>document.getElementById('form1')).action = this.dataLoaderService.vehicleInfo.hookURL + '';
        (<HTMLFormElement>document.getElementById('form1')).submit();
    }
    
    cancel(){
        this.dataLoaderService.flagDictionary.expertCancelFlag=false;
        this.dataLoaderService.flagDictionary.expertFlag=false;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/expert-screen-components/expert-cancel-confirmation/expert-cancel-confirmation.component.ts